import { formatPath } from './utils';
import { PlatformRouteNames } from './route-names';

import PlatformPanel from '../views/platform/PlatformPanel.vue';
import { RouteRecordRaw } from 'vue-router';

export const platformRouter: RouteRecordRaw[] = [
  {
    path: formatPath(PlatformRouteNames.Panel),
    name: PlatformRouteNames.Panel,
    component: PlatformPanel,
  },
];
